import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { publicApi } from "@/lib/api";
import { trackProductClick } from "@/lib/analytics";

const CATEGORIES = [
  { key: "all", label: "All" },
  { key: "mens", label: "Men's Apparel" },
  { key: "womens", label: "Women's Apparel" },
  { key: "apparel", label: "Hoodies & Outerwear" },
  { key: "prints", label: "Prints & Canvas" },
  { key: "diy_kits", label: "Paint-Your-Own Kits" },
  { key: "digital", label: "Digital Designs" },
  { key: "murals", label: "Murals" },
];

export default function Shop() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [category, setCategory] = useState("all");

  useEffect(() => {
    setLoading(true);
    const params = category === "all" ? {} : { category };
    publicApi.listProducts(params)
      .then((data) => setProducts(data))
      .finally(() => setLoading(false));
  }, [category]);

  return (
    <div data-testid="page-shop" className="max-w-[1400px] mx-auto px-5 md:px-10 py-16">
      <div className="mb-12">
        <p className="overline mb-3">The Drop</p>
        <h1 data-testid="shop-title" className="font-display text-5xl md:text-7xl">Shop CKA</h1>
        <p className="mt-4 text-white/60 max-w-2xl"><strong className="text-white">CamOriginal</strong> apparel, original prints, canvas artworks & digital designs. Every item ships direct from CKA — worldwide.</p>
      </div>

      <div className="flex flex-wrap gap-3 mb-10 border-b border-white/10 pb-6">
        {CATEGORIES.map((c) => (
          <button
            key={c.key}
            data-testid={`shop-filter-${c.key}`}
            onClick={() => setCategory(c.key)}
            className={`px-5 py-2 border text-xs uppercase tracking-widest transition-colors ${
              category === c.key
                ? "bg-[#FF4500] border-[#FF4500] text-white"
                : "border-white/20 text-white hover:border-white"
            }`}
          >
            {c.label}
          </button>
        ))}
      </div>

      {loading ? (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {[...Array(8)].map((_, i) => (
            <div key={i} className="aspect-[3/4] bg-white/5 animate-pulse" />
          ))}
        </div>
      ) : products.length === 0 ? (
        <div data-testid="shop-empty" className="py-24 text-center text-white/50">No products in this category yet.</div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {products.map((p) => (
            <Link
              key={p.id}
              to={`/shop/${p.id}`}
              data-testid={`shop-product-${p.id}`}
              onClick={() => trackProductClick(p.id, "shop_grid")}
              className="group hover-zoom"
            >
              <div className="aspect-[3/4] overflow-hidden bg-[#141414]">
                <img src={p.image_url} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="pt-4 flex justify-between items-start">
                <div>
                  <p className="font-display text-lg tracking-wider group-hover:text-[#FF4500] transition-colors">{p.title}</p>
                  <p className="text-xs text-white/50 uppercase tracking-widest">{p.category}</p>
                </div>
                <div className="text-right">
                  {p.category === "prints" && <p className="text-[10px] text-white/40 uppercase tracking-widest">From</p>}
                  <p className="text-[#FF4500] font-semibold">${p.price.toFixed(0)}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
